/* (i)-knop: rond, tikdoel 44 px, rustig (tekst 2); het blad toont de uitleg. */
.info {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: var(--b-touch, 44px);
  height: var(--b-touch, 44px);
  padding: 0;
  border: 0;
  border-radius: var(--b-radius-pill, 999px);
  background: transparent;
  color: var(--text-muted);
  cursor: pointer;
}

.info:hover {
  background: var(--surface-hover);
  color: var(--text);
}

.info:focus-visible {
  outline: 3px solid var(--focus-ring);
  outline-offset: 2px;
}

.body {
  max-width: var(--b-readable, 720px);
  font-size: var(--b-text-body);
  line-height: var(--b-line-body, 1.45);
}

.body > :first-child {
  margin-top: 0;
}

.body > :last-child {
  margin-bottom: 0;
}
